module.exports = __webpack_public_path__ + "img/iPad-Air.fa52534.png";